module.exports = __webpack_public_path__ + "static/media/AEP.645aaed8.svg";